import { jsxs as _jsxs } from "react/jsx-runtime";
const Button = ({ text, className, children, disabled, onClick }) => {
    return (_jsxs("button", { type: "button", disabled: disabled, className: className, onClick: onClick, children: [children, text] }));
};
export default Button;
